import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { Check, ChefHat, Package, CheckCircle2 } from 'lucide-react'
import { getNextStatuses } from '../utils'
import type { DeepOrder } from '../types'

interface StatusChangeButtonsProps {
  order: DeepOrder
  onStatusChange: (status: string) => void
  isLoading?: boolean
}

const statusConfig: Record<string, {
  icon: typeof Check
  labelKey: string
}> = {
  received:  { icon: Check,        labelKey: 'actions.markReceived' },
  confirmed: { icon: Check,        labelKey: 'actions.confirm' },
  preparing: { icon: ChefHat,      labelKey: 'actions.startPreparing' },
  ready:     { icon: Package,      labelKey: 'actions.markReady' },
  completed: { icon: CheckCircle2, labelKey: 'actions.complete' },
}

export function StatusChangeButtons({
  order,
  onStatusChange,
  isLoading = false,
}: StatusChangeButtonsProps) {
  const { t } = useTranslation('orders')

  if (order.cancelStatus === 'cancelled' || order.status.toLowerCase() === 'completed') {
    return null
  }

  const nextStatuses = getNextStatuses(order.status)
  if (nextStatuses.length === 0) return null

  return (
    <div className="flex flex-col gap-3">
      {nextStatuses.map((status) => {
        const config = statusConfig[status] ?? { icon: Check, labelKey: `status.${status}` }
        const Icon = config.icon

        return (
          <Button
            key={status}
            variant="default"
            size="kitchen"
            onClick={() => onStatusChange(status)}
            disabled={isLoading}
            className="w-full"
          >
            <Icon className="me-2" />
            {t(config.labelKey, t(`status.${status}`))}
          </Button>
        )
      })}
    </div>
  )
}
